import { Component } from '@angular/core';

@Component({
  selector: 'app-ownership-change',
  standalone: false,
  templateUrl: './ownership-change.component.html',
  styleUrl: './ownership-change.component.scss'
})
export class OwnershipChangeComponent {

  showIframeFlag: boolean = false;

  constructor() { }

  ngOnInit(): void {
    // Initialization logic can go here
  }

  showIframe() {
    this.showIframeFlag = true;
  }

}
